import { render } from "./emandate_terms.vue?vue&type=template&id=38a2e368&scoped=true"
import script from "./emandate_terms.vue?vue&type=script&lang=js"
export * from "./emandate_terms.vue?vue&type=script&lang=js"

import "./emandate_terms.vue?vue&type=style&index=0&id=38a2e368&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38a2e368"]])

export default __exports__